import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetSeriesDetail($input: GetSeriesDetailInput!) {
    getSeriesDetail(input: $input) {
      id
      image
      logo
      image_id
      twitter_image_id
      facebook_image_id
      facebook_image
      twitter_image
      logo_id
      added_by
      name
      short_name
      website
      schedule
      type_id
      bio
      twitter
      facebook
      instagram
      youtube
      tiktok
      user_id
      faqs {
        question
        answer
      }
      status
      account_id
      admin_infos {
        id
        logo
        logo_id
        link
        text
        info {
          id
          name
        }
        order
        video_url
        image_id
        image_url
        pdf_id
        pdf_url
      }
      url
      promoter_name
      promoter_email
      promoter_phone
    }
    getAllUsers {
      id
      name
      first_name
      middle_name
      last_name
      email
      role
    }
    getSeriesTypes {
      id
      value
      key
    }
  }
`;
export default graphql(query, {
  options: ({ match: { params } }) => {
    const currentSeries = Number(params.id);
    return {
      variables: { input: { id: currentSeries ? currentSeries : 0 } },
      fetchPolicy: 'cache-and-network',
    };
  },
});
